import { useTranslation } from 'react-i18next';
import FormWithProvider from 'components/forms/form/Form';
import SectionHeader from 'components/sectionHeader/SectionHeader';
import { CalendarExportSectionContainer } from './CalendarExportSection.styles';
import CalendarExportFields from './CalendarExportFields';

const CalendarExportSection = () => {
  const { t } = useTranslation();

  return (
    <CalendarExportSectionContainer data-testid="calendar-export-section">
      <SectionHeader
        id="calendar-export"
        title={t('pageAutomations.calendarTools.calendarExportSection.title')}
        subtitle={t(
          'pageAutomations.calendarTools.calendarExportSection.description',
        )}
      />
      <FormWithProvider
        horizontal
        onSubmit={() => {}}
        defaultValues={{
          includeTentativeReservations: true,
          includeGuestInformation: false,
          includeThirdPartyLeads: false,
        }}
      >
        <CalendarExportFields />
      </FormWithProvider>
    </CalendarExportSectionContainer>
  );
};

export default CalendarExportSection;
